import rowConfig from './rowConfig';

const getConfig = ({ columnsProps }) => ({
  className: 'h-model-terminal-table',
  rowConfig: rowConfig(columnsProps),
});

export default getConfig;
